import api from './api'

export interface AppNotification {
  id: string
  type: string
  title: string
  message: string
  isRead: boolean
  createdAt: string
}

export const notificationsService = {
  async getUnread(): Promise<AppNotification[]> {
    const res = await api.get('/notifications/unread')
    const d = res.data
    if (Array.isArray(d)) return d
    if (d?.success && Array.isArray(d.data)) return d.data
    return []
  },

  async markRead(id: string): Promise<void> {
    await api.put(`/notifications/${id}/read`)
  },

  async getMine(): Promise<AppNotification[]> {
    const res = await api.get('/notifications/mine')
    const d = res.data
    if (Array.isArray(d)) return d
    if (d?.success && Array.isArray(d.data)) return d.data
    return []
  },

  /** Manuel bildirim gönder — saha personeli (employee) ve/veya ofis çalışanı (user) */
  async send(payload: {
    employeeIds?: string[]
    userIds?: string[]
    title: string
    message: string
  }): Promise<{ sent: number; sentEmployees: number; sentUsers: number }> {
    const res = await api.post('/notifications/send', payload)
    return {
      sent: res.data?.data?.sent ?? 0,
      sentEmployees: res.data?.data?.sentEmployees ?? 0,
      sentUsers: res.data?.data?.sentUsers ?? 0,
    }
  },

  /** Gönderim geçmişi (batch bazında) */
  async getSent(): Promise<SentNotificationBatch[]> {
    const res = await api.get('/notifications/sent')
    const d = res.data
    if (Array.isArray(d)) return d
    if (d?.success && Array.isArray(d.data)) return d.data
    return []
  },
}

export interface SentNotificationBatch {
  batchId: string
  title: string
  message: string
  createdAt: string
  recipientCount: number
  employeeCount: number
  userCount: number
  readCount: number
}
